import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AppProvider, useApp } from "@/context/AppContext";
import TopNav from "@/components/vig/TopNav";
import GuidedTour from "@/components/vig/GuidedTour";
import Assistant from "@/components/vig/Assistant";
import Footer from "@/components/vig/Footer";
import Landing from "@/pages/Landing";
import Discover from "@/pages/Discover";
import Explore from "@/pages/Explore";
import Evaluate from "@/pages/Evaluate";
import Validate from "@/pages/Validate";
import Engage from "@/pages/Engage";
import Mobilise from "@/pages/Mobilise";
import InvestmentCase from "@/pages/InvestmentCase";
import Admin from "@/pages/Admin";
import Sources from "@/pages/Sources";

const Shell = () => {
  const { data, error } = useApp();
  if (error) return <div data-testid="app-error" className="p-10 text-red-300">Unable to load platform data: {error}</div>;
  if (!data) return <div data-testid="app-loading" className="min-h-screen grid place-items-center text-slate-400 text-sm tracking-widest">LOADING VAAL INVESTMENT GATEWAY…</div>;
  return (
    <>
      <TopNav />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/discover" element={<Discover />} />
        <Route path="/explore" element={<Explore />} />
        <Route path="/evaluate" element={<Evaluate />} />
        <Route path="/validate" element={<Validate />} />
        <Route path="/engage" element={<Engage />} />
        <Route path="/mobilise" element={<Mobilise />} />
        <Route path="/case" element={<InvestmentCase />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/sources" element={<Sources />} />
        <Route path="*" element={<Landing />} />
      </Routes>
      <Footer />
      <GuidedTour />
      <Assistant />
    </>
  );
};

export default function App() {
  return (
    <BrowserRouter>
      <AppProvider>
        <Shell />
        <Toaster theme="dark" position="top-right" richColors />
      </AppProvider>
    </BrowserRouter>
  );
}
